import { BaseDto } from '@/shared/dtos/base-dto';
import { ApexCharsSeries } from './ApexCharsSeries';

export class AltasDepacientes extends BaseDto {
    public data !: ApexCharsSeries[];
    public categories!: string[];
} 
